import React, { PropTypes } from 'react';
import Modal from 'react-modal';
import B from 'bem-cn';

import './overlay.scss';

const cl = B('Overlay');

export default function Overlay({ setOverlay, children, showedOverlay }) {
  let modalLabel;
  switch (showedOverlay) {
    case 'forms__contactForm':
      modalLabel = 'Contact form';
      break;
    case 'forms__requestDemo':
      modalLabel = 'Request demo';
      break;
    case 'forms__investorRelations':
      modalLabel = 'Investor relations';
      break;
    case 'forms__registerInterest':
      modalLabel = 'Register interest';
      break;
    default:
      modalLabel = 'Unexpected overlay';
  }

  const onCloseClick = e => {
    e.preventDefault();
    setOverlay();
  };

  return (
    <Modal
      isOpen
      onRequestClose={() => setOverlay()}
      contentLabel={modalLabel}
      className={cl('content')}
      overlayClassName={cl('overlay')}
    >
      <a className={cl('content', 'close')} href="" onClick={onCloseClick}>
        Close
      </a>
      {children}
    </Modal>
  );
}

Overlay.propTypes = {
  children: PropTypes.element.isRequired,
  setOverlay: PropTypes.func.isRequired,
  showedOverlay: PropTypes.string
};



// WEBPACK FOOTER //
// ../src/components/overlay/overlay.jsx